module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_active.a0fc78c12bc761df7e1b32f1640e6cda.png";